module.exports = __webpack_public_path__ + "img/a01.a0247296.svg";